import * as React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { Size } from '../../types';
import { colors, sizes } from '../../styles';
import { Dismissible } from '../../utils/dismissible';
import { PortalWrapper } from '../../utils/portal-wrapper';
import { IconButton } from '../buttons';
import { FlyoutMenu } from './';
import { DropdownProps, DropdownListItemProps } from './props';

export interface Props {
  asPortal?: boolean;
  className?: string;
  closeOnScroll?: boolean;
  id?: string;
  listOptions?: DropdownListItemProps[];
  menuIconSize?: Size;
  triggerIconSize?: Size;
  showTriggerOnlyOnHover?: boolean;
  isHovered?: boolean;
  dataTest?: string;
}

interface State {
  open: boolean;
}

class Flyout extends React.Component<Props, State> {
  public static defaultProps: Props = {
    asPortal: false,
    closeOnScroll: false,
    listOptions: [],
    triggerIconSize: 'md',
    showTriggerOnlyOnHover: false,
    dataTest: '',
  };
  public state: State = { open: false };

  private element: HTMLElement = null;

  public render() {
    const {
      className,
      closeOnScroll,
      triggerIconSize,
      showTriggerOnlyOnHover,
      isHovered,
      asPortal,
      id,
      listOptions,
      menuIconSize,
      dataTest,
    } = this.props;
    const { open } = this.state;

    const btn = (
      <IconButton
        className="trigger"
        icon="kebabMenuVertical"
        size={triggerIconSize}
        onClick={this.toggleFlyout}
        dataTest={dataTest}
      />
    );

    const menu = (
      <FlyoutMenu
        className="menu"
        id={id}
        listOptions={listOptions}
        triggerIconSize={triggerIconSize}
        {...(menuIconSize ? { menuIconSize } : {})}
      />
    );

    return (
      <div className={className} ref={this.memoizeElement}>
        {showTriggerOnlyOnHover ? isHovered && btn : btn}
        {open && (
          <Dismissible
            onClick={this.toggleFlyout}
            onClickAway={this.closeFlyout}
            {...(closeOnScroll ? { onScroll: this.closeFlyout } : {})}
          >
            {asPortal ? (
              <PortalWrapper shadowElement={this.element}>{menu}</PortalWrapper>
            ) : (
              menu
            )}
          </Dismissible>
        )}
      </div>
    );
  }

  private closeFlyout = e => this.setState({ open: false });
  private memoizeElement = el => (this.element = el);
  private toggleFlyout = e =>
    this.setState(nextState => ({ open: !nextState.open }));
  componentDidUpdate(prevProps) {
    if (prevProps.listOptions.length !== this.props.listOptions.length) {
      this.setState(state => ({ ...state, open: true }));
    }
  }
}

const StyledFlyout = styled(Flyout)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding-left: 0.5rem;

  .trigger {
    width: 1rem;
    height: 2rem;
    margin-right: 1rem;
    cursor: pointer;

    &:hover {
      g {
        fill: ${colors.green500};
      }
    }
  }
`;

export default StyledFlyout;
